import {
    ACTUALIZAR_LIST_EQPG,
    AGREGAR_EQPG,
  } from "./eqpgActions";

  const eqpgReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_EQPG: {
            return {
                ...state,
                eqpgIDLista: action.payload
            }
        };

        case AGREGAR_EQPG:{
            return {
                 ...state,
                 eqpgIDLista: [action.payload, ...state.eqpgIDLista]
             }
         };

        default:
            return state;

    }
  }

  export default eqpgReducer;
